import { render, staticRenderFns } from "./locale.vue?vue&type=template&id=8e3e3ab8&scoped=true"
import script from "./locale.vue?vue&type=script&lang=js"
export * from "./locale.vue?vue&type=script&lang=js"
import style0 from "./locale.vue?vue&type=style&index=0&id=8e3e3ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3e3ab8",
  null
  
)

export default component.exports